export const SHARE_MOBILE_PLUGIN_NAME = 'no-edit-share-mobile';

export const SHARE_PC_PLUGIN_NAME = 'no-edit-share-pc';

